import React from 'react';

import { STYLE_DISPLAY_NONE } from 'constants/misc.const';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';

const HiddenDiv = ({ tag, subtag, children, id, ...extra }) => (
  <div
    data-bem="HiddenDiv"
    data-tag={fromAnyToTrimmed(tag)}
    data-subtag={fromAnyToTrimmed(subtag)}
    style={STYLE_DISPLAY_NONE}
    id={id}
    {...extra}
  >
    {children}
  </div>
);

export default HiddenDiv;
